module.exports = __webpack_public_path__ + "img/neural.da55d797.png";